import React from "react";
import { Link } from "gatsby";

import {
  Highlight,
  Hits,
  Index,
  Snippet,
  PoweredBy,
  useStats,
} from "react-instantsearch";
const HitCount = () => {
  const { nbHits } = useStats();

  return nbHits > 0 ? (
    <div className="HitCount text-black">
      {nbHits} result{nbHits !== 1 ? "s" : ""}
    </div>
  ) : null;
};

const PageHit = ({ hit }) => (
  <>
    <Link to={`/${hit.Slug}`}>
      {/* <Highlight attribute="title" hit={hit} /> */}
      <Highlight attribute="Title" hit={hit} tagName="mark" />
      <Snippet attribute="excerpt" hit={hit} tagName="mark" />
    </Link>
  </>
);

const HitsInIndex = ({ index }) => (
  <Index indexName={index.name}>
    <HitCount />
    <Hits className="Hits" hitComponent={PageHit} />
  </Index>
);

const SearchResult = ({ indices, className }) => (
  <div className={className}>
    {indices.map((index) => (
      <HitsInIndex index={index} key={index.name} />
    ))}
    {/* <PoweredBy /> */}
  </div>
);

export default SearchResult;
